import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getStandartTimings = createAsyncThunk(
    'communication/getStandartTimings',
    async () => {
        const { data } = await http.get('api/v1/wct');
        return data.data;
    },
);

export const storeStandartTimings = createAsyncThunk(
    'communication/storeStandartTimings',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/wct', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

// export const getPackageById = createAsyncThunk(
//     'insurance/getPackageById',
//     async (id) => {
//         const { data } = await insuranceApi.get(`api/v1/packages/${id}`);
//         return data.data;
//     },
// );

// export const editPackage = createAsyncThunk(
//     'users/editPackage',
//     async ({ id, body }, { rejectWithValue }) => {
//         try {
//             const { data } = await insuranceApi.put(
//                 `api/v1/packages/${id}`,
//                 body,
//             );
//             return data.data;
//         } catch (error) {
//             return rejectWithValue(error.response.data);
//         }
//     },
// );

// export const deletePackage = createAsyncThunk(
//     'insurance/deletePackage',
//     async (id, { rejectWithValue }) => {
//         try {
//             const { data } = await insuranceApi.delete(`api/v1/packages/${id}`);
//             return data.data;
//         } catch (error) {
//             return rejectWithValue(error.response.data);
//         }
//     },
// );

const initialState = {
    timingsLoadingStatus: 'idle',
    timings: [],
};

export const communicationSlice = createSlice({
    name: 'communication',
    initialState,
    reducers: {},
    extraReducers: {
        [getStandartTimings.pending]: (state, action) => {
            state.timingsLoadingStatus = 'loading';
        },
        [getStandartTimings.fulfilled]: (state, action) => {
            state.timingsLoadingStatus = 'succeeded';
            state.timings = action.payload;
        },
        [getStandartTimings.rejected]: (state, action) => {
            state.timingsLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allTimings = (state) => state.communication.timings;
export const timingsLoadingStatus = (state) =>
    state.communication.timingsLoadingStatus;
// export const onePackage = (state) => state.insurance.package;
// export const packageLoadingStatus = (state) =>
//     state.insurance.packageLoadingStatus;

export default communicationSlice.reducer;
